import { createSelector } from 'reselect';
import { Map as IMap } from 'immutable';
import { getLoyaltyNumber as getAuthLoyaltyNumber } from '../auth/authSelectors';

export const getLoyalty = state => state.get('loyalty', IMap());




export const getLoyaltyNumber = createSelector(
    getLoyalty,
    getAuthLoyaltyNumber,
    (loyalty, authLoyaltyNumber) => loyalty.get('loyaltyNumber', '') || authLoyaltyNumber || ''
);
